
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";
import EnhancedLoginForm from "./EnhancedLoginForm";

export default function LoginForm() {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // The checking and redirecting of authenticated users is now handled in the Login page
  // This component just renders the form
  
  return <EnhancedLoginForm />;
}
